import { useActivePlannerId, useNavigateAsync, useViewModel } from '@/hooks';
import { Checkbox, FormControlLabel, Stack, Typography } from '@mui/material';
import { observer } from 'mobx-react-lite';
import LocalizedStrings from 'strings';
import { Dialog } from '../../utils';

export interface AiSuggestedStepsDialogProps {
  /**
   * Id of the work associated to the planned work to
   * edit.
   */
  workId: string;

  isOpen: boolean;
}

export const AiSuggestedStepsDialog = observer(({ workId, isOpen }: AiSuggestedStepsDialogProps) => {
  const navigate = useNavigateAsync();
  const plannerId = useActivePlannerId();

  const strings = LocalizedStrings.work.compassStepPicker;
  const viewModel = useViewModel((viewModels) =>
    viewModels.createAiSuggestedStepsViewModel(workId, plannerId, dismiss, dismiss)
  );

  function dismiss() {
    return navigate(-1);
  }

  return (
    <Dialog
      isOpen={isOpen}
      viewModel={viewModel}
      title={strings.dialogTitle()}
      width="sm"
      submit={() => void viewModel.save()}
      renderData={() => (
        <Stack sx={{ width: '100%' }} spacing={2}>
          <Typography variant="subtitle1">{strings.dialogSubtitle()}</Typography>
          <Typography variant="subtitle2">{strings.reasons()}</Typography>
          <Typography variant="body2">{viewModel.reason}</Typography>
          <Typography variant="subtitle2">{strings.suggestedSteps()}</Typography>
          <Stack spacing={1}>
            {viewModel.suggestedSteps?.map((step, index) => (
              <Stack key={index} direction="row" alignItems="center" spacing={1}>
                <FormControlLabel
                  control={
                    <Checkbox
                      checked={viewModel.selectedStepIndexes.has(index)}
                      onChange={(event) => viewModel.changeStepSelection(index, event.target.checked)}
                    />
                  }
                  label={<Typography variant="body2">{step}</Typography>}
                  sx={{ margin: 0 }}
                />
              </Stack>
            ))}
          </Stack>
        </Stack>
      )}
    />
  );
});
